export function Brand({ large = false }) {
  return (
    <div className={`brand ${large ? "large" : ""}`}>
      <strong>LetzBook</strong>
    </div>
  );
}
